export default __webpack_public_path__ + "static/char-v-10-f30854eee013f6d5a321efce422203bc.png";